import RootStoreContext from '~/contexts/RootStoreContext';
import async from '~/utils/async';
import resolver from './CustomPageLayout.resolver';
import CustomPageLayout from './CustomPageLayout';

export default async(resolver, { context: RootStoreContext })(CustomPageLayout);
